export function HelpCircleIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_3965_30384)">
        <path d="M7.57508 7.50033C7.771 6.94338 8.15771 6.47375 8.66671 6.1746C9.17571 5.87546 9.77416 5.76611 10.3561 5.86592C10.938 5.96573 11.4658 6.26826 11.846 6.71993C12.2262 7.1716 12.4343 7.74326 12.4334 8.33366C12.4334 10.0003 9.93341 10.8337 9.93341 10.8337M10.0001 14.167H10.0084M18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C5.39771 18.3337 1.66675 14.6027 1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3965_30384">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "HelpCircleIcon";
